import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core'
import { MatIconModule } from '@angular/material/icon'
import { IconLibrary } from './gb-icon-library.models'
@Component({
  selector: 'gb-icon',
  templateUrl: './gb-icon.component.html',
  styleUrls: ['./gb-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MatIconModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class GbIconComponent {
  private _library: IconLibrary = IconLibrary.ionic

  @Input() icon = ''
  @Input() height = '26px'
  @Input() set library(value: IconLibrary | undefined) {
    this._library = value ?? IconLibrary.ionic
  }

  get library(): IconLibrary {
    return this._library
  }

  IconLibrary = IconLibrary
}
